import React from "react";
import styled from "styled-components";

const StyledCard = styled.div`
  background-color: var(--surface-color);
  border: 1px solid var(--border-color-light);
  border-radius: var(--border-radius);
  box-shadow: var(--luxury-shadow);
  padding: 2rem;
  width: 100%;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--gold-gradient);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1.25rem;
    border-radius: 6px;
  }

  ${(props) =>
    props.hover &&
    `
    transition: var(--transition);
    &:hover {
      transform: translateY(-4px);
      box-shadow: var(--gold-shadow);
    }
  `}
`;

const CardHeader = styled.div`
  margin-bottom: 1.5rem;

  h2 {
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    color: var(--text-color);

    @media (max-width: 768px) {
      font-size: 1.3rem;
    }

    @media (max-width: 480px) {
      font-size: 1.2rem;
    }
  }

  h3 {
    margin-bottom: 0.5rem;
    color: var(--text-color);
  }

  p {
    color: var(--text-secondary);
    margin-bottom: 0;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }
`;

const CardBody = styled.div``;

const CardFooter = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: ${(props) => props.align || "flex-end"};

  > * + * {
    margin-left: 1rem;
  }

  @media (max-width: 576px) {
    flex-direction: ${(props) => (props.stackOnMobile ? "column" : "row")};

    > * + * {
      margin-left: ${(props) => (props.stackOnMobile ? "0" : "1rem")};
      margin-top: ${(props) => (props.stackOnMobile ? "1rem" : "0")};
    }
  }
`;

const Card = ({ children, hover, ...props }) => {
  return (
    <StyledCard hover={hover} {...props}>
      {children}
    </StyledCard>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
